import { Action } from '../../redux/redux.types';

import {
  ORGANIZATION_LEVEL_MENU_ITEMS,
  PROJECT_LEVEL_MENU_ITEMS,
} from './sidebar.constants';
import { SidebarState } from './sidebar.types';

const defaultState: SidebarState = {
  organizationLevel: ORGANIZATION_LEVEL_MENU_ITEMS,
  projectLevel: PROJECT_LEVEL_MENU_ITEMS,
};

export const sidebar = (
  state: SidebarState = defaultState,
  { type }: Action,
) => {
  switch (type) {
    default: {
      return state;
    }
  }
};
